import { Compass, Map, Rocket } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const chapters = [
  {
    num: "01",
    title: "Dream",
    icon: Compass,
    desc: "Tell us what you want from your education and life beyond graduation. Our mentoring starts with understanding you.",
    span: "lg:col-span-4",
  },
  {
    num: "02",
    title: "Pursue",
    icon: Map,
    desc: "Turn your ambitions into a study plan, with guidance on courses, universities, applications and preparing for life abroad.",
    span: "lg:col-span-4",
  },
  {
    num: "03",
    title: "Become",
    icon: Rocket,
    desc: "Deepen your knowledge, broaden your perspective and grow through an international education that opens up new horizons.",
    span: "lg:col-span-4",
  },
];

export const Journey = () => (
  <section
    id="journey"
    data-testid="journey-section"
    className="relative pt-20 pb-8 lg:pt-28 lg:pb-12 bg-[#FFFFFF]"
  >
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <Reveal>
        <Overline testid="journey-overline">The Movementor journey</Overline>
        <h2
          data-testid="journey-heading"
          className="mt-6 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-[#111111] max-w-2xl"
        >
          Three chapters. One direction —{" "}
          <span className="text-gradient">yours.</span>
        </h2>
      </Reveal>

      <div className="mt-10 lg:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6">
        {chapters.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.12} className={c.span}>
            <article
              data-testid={`journey-chapter-${c.num}`}
              className="group relative h-full bg-white rounded-3xl border border-black/5 p-7 lg:p-9 overflow-hidden hover:-translate-y-2 hover:shadow-2xl hover:shadow-orange-500/10 transition-[transform,box-shadow] duration-500"
            >
              <span className="absolute -top-6 -right-2 text-[7rem] lg:text-[10rem] font-black text-outline opacity-60 select-none leading-none group-hover:opacity-100 transition-opacity duration-500">
                {c.num}
              </span>
              <div className="relative">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#FE7815] to-[#F01E1F] flex items-center justify-center">
                  <c.icon className="w-6 h-6 text-white" strokeWidth={2.2} />
                </div>
                <h3 className="mt-6 text-xl sm:text-2xl font-semibold text-[#111111] uppercase tracking-wide">
                  {c.title}
                </h3>
                <p className="mt-4 text-sm sm:text-base text-[#111111] leading-relaxed max-w-lg">
                  {c.desc}
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
